import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0A0A0A] text-zinc-400">
        Caricamento...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
